module.exports = __webpack_public_path__ + "img/thumbnail_HoneyBadger_f_melanistic.c83e35d3.png";